/**
 * @generated SignedSource<<184f2e2419ab090e18a83fd44966c14d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPhotosGrid_searchResult$data = {
  readonly project: {
    readonly tradePhotos: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectPhoto_tradePhoto">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ProjectPhotosGrid_searchResult";
};
export type ProjectPhotosGrid_searchResult$key = {
  readonly " $data"?: ProjectPhotosGrid_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPhotosGrid_searchResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPhotosGrid_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "designProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhoto",
          "kind": "LinkedField",
          "name": "tradePhotos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProjectPhoto_tradePhoto"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeInteriorProjectQueryOutput",
  "abstractKey": null
};

(node as any).hash = "8f1e15a5fa612bb1e95418834a4ece92";

export default node;
